import React from "react";
import DataTable from "@/components/Datatable/Datatable";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import SearchInput from "@/components/SearchInput/SearchInput";
import { ProductStoreCategory } from "../../api/fetchProductStoreCategories/types";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import CategoryDialog from "../CategoryDialog/CategoryDialog";
import DeleteCategoryModal from "../DeleteCategoryModal/DeleteCategoryModal";
import { useCategoryList } from "../../hooks/useCategoryList";

const CategoryList: React.FC = () => {
  const {
    categories,
    totalCount,
    loading,
    error,
    pagination,
    sorting,
    filters,
    handlePaginationChange,
    handleSortingChange,
    handleFilterChange,
    columns,
    isDialogOpen,
    editingCategory,
    deleteDialogState,
    handleCreateCategory,
    closeCategoryDialog,
    closeDeleteDialog,
    handleConfirmDelete,
    refreshList,
  } = useCategoryList();

  return (
    <MainPageWrapper
      actions={
        <Button
          className="flex items-center gap-1"
          onClick={handleCreateCategory}
          size="sm"
        >
          <Plus className="w-4 h-4" />
          New Category
        </Button>
      }
      error={error}
      subtitle="Manage categories for organizing products"
      title="Product Categories"
    >
      <div className="mb-4 flex items-center space-x-2">
        <div className="max-w-md w-full">
          <SearchInput
            onChange={(searchTerm: string) => handleFilterChange(searchTerm)}
            placeholder="Search categories..."
            value={filters.searchTerm || ""}
          />
        </div>
        <select
          className="px-3 py-2 pr-10 flex h-9 rounded-md border border-input bg-white text-base shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring md:text-sm dark:bg-slate-800 dark:border-slate-700 dark:text-slate-100"
          onChange={(e) =>
            handleFilterChange(
              filters.searchTerm || "",
              parseInt(e.target.value, 10),
            )
          }
          value={filters.isActive}
        >
          <option value={1}>Active</option>
          <option value={0}>Inactive</option>
        </select>
      </div>
      <div className="relative">
        <DataTable<ProductStoreCategory>
          columns={columns}
          data={categories}
          error={error}
          loading={loading}
          noDataMessage="No categories found. Create one to get started."
          onPageChange={(newPageIndex, newPageSize) =>
            handlePaginationChange({
              pageIndex: newPageIndex,
              pageSize: newPageSize,
            })
          }
          onSortingChange={handleSortingChange}
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          rowKeyExtractor={(item) => item.id}
          sorting={sorting}
          totalCount={totalCount}
        />
      </div>

      <CategoryDialog
        category={editingCategory}
        isOpen={isDialogOpen}
        onClose={closeCategoryDialog}
        onSuccess={refreshList}
      />

      <DeleteCategoryModal
        categoryName={deleteDialogState.categoryName}
        isOpen={deleteDialogState.isOpen}
        onClose={closeDeleteDialog}
        onConfirm={handleConfirmDelete}
      />
    </MainPageWrapper>
  );
};

export default CategoryList;
